import BenefitsSettingsPage from 'modules/benefits/pages/settings'

const BenefitsPage = () => {
  return <BenefitsSettingsPage />
}

export default BenefitsPage
